type RouteHandler = (params: URLSearchParams) => void | Promise<void>;

const routes = new Map<string, RouteHandler>();

export function register(name: string, handler: RouteHandler): void {
  routes.set(name, handler);
}

export function navigate(name: string, params: Record<string, string> = {}): void {
  const search = new URLSearchParams(params).toString();
  const hash = search ? `#${name}?${search}` : `#${name}`;
  if (location.hash !== hash) location.hash = hash;
  else void resolve();
}

export function back(): void {
  if (history.length > 1) history.back();
  else navigate("home");
}

async function resolve(): Promise<void> {
  const raw = (location.hash || "#home").slice(1);
  const [name, query = ""] = raw.split("?");
  const handler = routes.get(name) ?? routes.get("home");
  if (!handler) return;
  const params = new URLSearchParams(query);
  await handler(params);
  window.scrollTo(0, 0);
}

export function start(): void {
  window.addEventListener("hashchange", () => void resolve());
  void resolve();
}
